import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from '../context/index';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from 'classnames';
import { ToastContainer } from 'react-toastify';
import { motion } from 'framer-motion';

import TopNav from "./TopNav";
import Sidebar from "./Sidebar";
import ModalConfirmLocation from '../components/ModalConfirmLocation';
import ModalLoading from '../components/custom/ModalLoading';
import ModalSearchAwb from './searchAwb/index';
import LogAddNotes from "./logNotes/LogAddNotes";
import { socket } from '../context/socket';
import { notify } from "../utils";
import ActiveUsersFooter from "./activeUsersFooter";
import ModalConfirmation from "./custom/ModalConfirmation";
import ViewChangeLog from "./ViewChangeLog";
import PasswordManager from "./passwordManager";
import ConfirmationModal from "./ConfirmationModal";
import BugReport, { bugReportModalState, bugReportScreenshotState } from "./IssueReporting";
import { useSetRecoilState } from "recoil";
import domtoimage from 'dom-to-image-more';
import BugReportButton from "./BugReportButton";
import IssueReporting from "./IssueReporting";

const AppLayout = (props) => {

    const {
        user,
        setUser,
        displaySubmenu,
        setDisplaySubmenu,
        modalLocation,
        setModalLocation,
        loading,
        setLoading,
        readingSigns,
        accessMap,
        accessMapAssigned,
        darkMode
    } = useContext(AppContext);

    const { path, containerClassnames, history, children, width, padding } = props;

    const [broadcastUpdate, setBroadcastUpdate] = useState(false);
    const [viewChangeLog, setViewChangeLog] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        const socketBroadcast = (message, update) => {
            notify(message.toUpperCase(), 'info');
            if (update) {
                setBroadcastUpdate(true);
            }
        }
        socket.on('broadcast', socketBroadcast);
        return () => {
            socket.off('broadcast', socketBroadcast);
        }
    }, []);

    const setBugReportModal = useSetRecoilState(bugReportModalState);
    const setBugRepScreenshot = useSetRecoilState(bugReportScreenshotState);

    const node = document.body;

    const handleReportBug = async () => {
        // First call primes the cache, ignore its result
        domtoimage.toPng(node).then((dataUrl) => {
            setLoading(false);
            setBugRepScreenshot(dataUrl);
            setBugReportModal(true);
        });
    }

    return (
        <div id="app-container" className={containerClassnames} style={{ padding }} ref={rootRef}>
            <TopNav
                path={path}
                history={history}
                user={user}
                setModalLocation={setModalLocation}
                handleDisplaySubmenu={setDisplaySubmenu}
                width={width}
                broadcastUpdate={broadcastUpdate}
                setViewChangeLog={setViewChangeLog}
                handleReportBug={handleReportBug}
            />
            <Sidebar
                user={user}
                readingSigns={readingSigns}
                handleDisplaySubmenu={setDisplaySubmenu}
                darkMode={darkMode}
                accessMap={accessMap}
                accessMapAssigned={accessMapAssigned}
            />
            <motion.div
                key={window.location.pathname}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0, y: 100 }}
            >
                <main className={'main-container'} style={{ margin: `75px 0px 0px 120px`, overflowY: 'hidden' }}>
                    <div className={classnames(`container-fluid`, { 'reduced-width': displaySubmenu })} style={{ overflowY: 'hidden' }}>
                        {children}
                    </div>
                    <ActiveUsersFooter />
                </main>
            </motion.div>
            <ModalConfirmLocation
                open={modalLocation}
                handleModal={setModalLocation}
                user={user}
                setUser={setUser}
                units={user.authorizedUnits}
            />
            <ModalLoading
                modal={loading}
                setModal={setLoading}
            />
            <ModalSearchAwb />
            <LogAddNotes />
            <ToastContainer />
            <ViewChangeLog
                modal={viewChangeLog}
                setModal={setViewChangeLog}
            />
            <PasswordManager />
            <ConfirmationModal />
            <IssueReporting />
            <BugReportButton
                onReport={handleReportBug}
            />
        </div>
    );
}

const mapStateToProps = ({ menu }) => {
    const { containerClassnames } = menu;
    return { containerClassnames };
};

const mapActionToProps = {}

export default withRouter(connect(
    mapStateToProps,
    mapActionToProps
)(React.memo(AppLayout)));
